// extracted by mini-css-extract-plugin
module.exports = {"projectSubnavbar":"ProjectSubnavbar_projectSubnavbar__2wKVc"};